import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "semantic-ui-css/semantic.min.css";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import "react-phone-number-input/style.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import NovoPedido from "./features/NovoPedido/NovoPedido";
import AcompanharPedido from "./features/AcompanharPedido/AcompanharPedido";
import RegistrarAtividade from "./features/RegistrarAtividade/RegistrarAtividade";
import ConfirmarIdentidade from "./features/ConfirmarIdentidade/ConfirmarIdentidade";
import { CookiesProvider } from 'react-cookie';
import *  as Sentry from "@sentry/react";
import ReactPixel from 'react-facebook-pixel';
import ReactGA from "react-ga4";

ReactPixel.init('1141481850453337', {}, {
  autoConfig: true,
  debug: false,
});
ReactPixel.pageView();

ReactGA.initialize('G-CBC5WHNNG6');

Sentry.init({
  release: 'filie-se@' + (process.env.REACT_APP_VERSAO || 'nao-informado'),
  environment: process.env.NODE_ENV || 'production',
  dsn: "https://9135d48895174e878eaa13edd8fedb2a@o994633.ingest.sentry.io/4505338905755648",
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 0.2,
});


const router = createBrowserRouter([
  {
    path: "/",
    element: <NovoPedido />,
  },
  {
    path: "/acompanhar-pedido",
    element: <AcompanharPedido />,
  },
  {
    path: "/registrar-atividade",
    element: <RegistrarAtividade />,
  },
  {
    path: "/confirmar-identidade",
    element: <ConfirmarIdentidade />,
  },
  {
    path: "/confirmar-identidade/:codigo",
    element: <ConfirmarIdentidade />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <RouterProvider router={router} />
    </CookiesProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
